function GiftExcelUploadModal({
  isEditMode,
  closeModal,
  setView,
  view,
  fileInputRef,
  handleExcelFileChange,
  handleExcelSubmit,
  message,
  uploadRows,
}) {
  return (
    <div
      className="modal fade"
      id="newGiftExcelModal"
      tabIndex="-1"
      aria-labelledby="newUserModalLabel"
      aria-hidden="true"
    >
      <div
        className={`modal-dialog ${
          view === "manual"
            ? "modal-fullscreen"
            : "modal-dialog-centered modal-md"
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="newUserModalLabel">
              {isEditMode ? "Edit Donor" : "Add Donor"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                closeModal();
                setView("excel");
              }}
            ></button>
          </div>

          <div className="modal-body">
            {view === "excel" && (
              <>
                <div className="mb-3">
                  <label htmlFor="excelUpload" className="form-label">
                    Upload Excel File (.xlsx)
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="excelUpload"
                    accept=".xlsx"
                    ref={fileInputRef}
                    onChange={handleExcelFileChange}
                  />
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0 text-primary"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = "/samples/donor_sample.xlsx";
                        link.download = "donor_sample.xlsx";
                        link.click();
                      }}
                    >
                      Download Sample Sheet
                    </button>
                  </div>

                  <div className="alert alert-warning mt-2" role="alert">
                    <strong>Note:</strong> Status must be one of the following:
                    <ul className="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                      <li>
                        <span className="badge bg-secondary">submitted</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">accepted</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">rejected</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">on-hold</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">active</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">inactive</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">closed</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">pending</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">deactivated</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">
                          NPCI rejected
                        </span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">
                          TPSL rejected
                        </span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">
                          NPCI acknowledged
                        </span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">success</span>
                      </li>
                    </ul>
                  </div>

                  <div className="alert alert-warning mt-2" role="alert">
                    <strong>Note:</strong> is address confirmed must be one of
                    the following:
                    <ul className="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                      <li>
                        <span className="badge bg-secondary">yes</span>
                      </li>
                      <li>
                        <span className="badge bg-secondary">no</span>
                      </li>
                    </ul>
                  </div>

                  <button
                    className="btn btn-success mt-3"
                    onClick={handleExcelSubmit}
                  >
                    Upload
                  </button>
                  {message && <div className="mt-2">{message}</div>}

                  {uploadRows.length > 0 && (
                    <div className="mt-3">
                      <h5>Upload Summary:</h5>
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Row</th>
                            <th>Status</th>
                            <th>Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          {uploadRows.map((rowData, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{rowData?.row}</td>
                              <td
                                style={{
                                  color:
                                    rowData?.status === "fail"
                                      ? "red"
                                      : "green",
                                  fontWeight: "bold",
                                }}
                              >
                                {rowData?.status}
                              </td>
                              <td>{rowData?.reason || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GiftExcelUploadModal;
